import { fireAnalytics } from '../firebase.js'
import { getDeviceCategory, getSessionId } from '../analyticsHelpers.ts'

export type MaterialsQuotationFlow = 'crear' | 'estimacion'

export type MaterialsQuotationEntryPath = 'manual' | 'ai_file'

export type MaterialsCommerceSupplierCtaOrigin = 'browse_panel'

const ENTRY_EVENT = 'materials_quotation_entry'
const COMMERCE_SUPPLIER_CTA_EVENT = 'materials_flow_commerce_cta_click'

function baseParams(edifyUserId: string, flow: MaterialsQuotationFlow) {
  return {
    category: 'materials_quotation' as const,
    edify_user_id: edifyUserId || undefined,
    session_id: getSessionId(),
    device_category: getDeviceCategory(),
    flow,
  }
}

export function trackMaterialsQuotationScreenView(
  edifyUserId: string,
  flow: MaterialsQuotationFlow
): void {
  fireAnalytics('create_quotation', {
    ...baseParams(edifyUserId, flow),
    action: 'create_quotation',
    user_info: edifyUserId,
  })
}

export function trackMaterialsQuotationEntryPath(
  edifyUserId: string,
  flow: MaterialsQuotationFlow,
  entryPath: MaterialsQuotationEntryPath
): void {
  fireAnalytics(ENTRY_EVENT, {
    ...baseParams(edifyUserId, flow),
    action: ENTRY_EVENT,
    entry_path: entryPath,
  })
}

export function trackMaterialsCommerceSupplierCtaClick(
  edifyUserId: string,
  flow: MaterialsQuotationFlow,
  origin: MaterialsCommerceSupplierCtaOrigin,
  target: 'alta' | 'catalogo'
): void {
  fireAnalytics(COMMERCE_SUPPLIER_CTA_EVENT, {
    ...baseParams(edifyUserId, flow),
    action: COMMERCE_SUPPLIER_CTA_EVENT,
    origin,
    target,
  })
}
